import { render } from "./Recherche.vue?vue&type=template&id=4541c089"
import script from "./Recherche.vue?vue&type=script&lang=js"
export * from "./Recherche.vue?vue&type=script&lang=js"
script.render = render

export default script